export const DETAILS_MAP_RESTRICTED = {
  ORIGINAL: 'Unavailable until the video is approved',
  HD: 'Unavailable until the video is approved',
  SD: 'A lower quality video, used for previews or slow connections'
};